import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { StaticTimer, Timer } from './timer';
import { Modal } from './modal';
import { FormatTime } from './timer';
import './new-timer.css';
import Plus from '@material-ui/icons/AddCircleOutline';
import ExpandMore from '@material-ui/icons/ExpandMore';
import ExpandLess from '@material-ui/icons/ExpandLess';
import BackIcon from '@material-ui/icons/ArrowBack';
import EditIcon from '@material-ui/icons/Edit';
import Link from '@material-ui/icons/Link';
import { useHistory, useParams } from 'react-router';
import { EditLap } from './edit-lap';
import { tsPropertySignature } from '@babel/types';

export type Runner = { name: string, laps: { time: number, comment: string }[], stopTime: number };
export type LapPair = { name: string, lap: number };
const API_URL = 'https://stanley5.com:9501';
// const API_URL = 'http://localhost:9501';

export function NewTimerPage() {
  const [status, setStatus] = useState<'Not Started' | 'Running' | 'Stopped'>('Not Started');
  const [socket, setSocket] = useState<WebSocket>();
  const [loading, setLoading] = useState(true);
  const [startTime, setStartTime] = useState(Date.now());
  const [stopTime, setStopTime] = useState(0);
  const [saved, setSaved] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [resetModalOpen, setResetModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState<LapPair | undefined>();
  const [name, setName] = useState('Session');
  const [addingRunner, setAddingRunner] = useState('');
  const [runners, setRunners] = useState<Runner[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);
  const history = useHistory();

  let { session }: any = useParams();

  useEffect(() => {
    setSocket(new WebSocket('wss://stanley5.com:9501'));
    // setSocket(new WebSocket('ws://localhost:9501'))
    return (() => {
      socket?.close()
    });
  }, [])

  useEffect(() => {
    if (socket) {
      socket.onmessage = (event) => onSocketMessage(event);
    }
  }, [socket])


  useEffect(() => {
    GetInitialInfo();
  }, [session])

  async function GetInitialInfo() {
    fetch(API_URL + `/get-session/${session}`, {
      method: 'GET'
    })
      .then(async (res) => {
        if (!res.ok) {
        }
        return (await res.json());
      })
      .then((data) => {
        if (data[0].startTime) {
          setStartTime(data[0].startTime);
          setStatus('Running')
        }
        setName(data[0].name);
        if (data[0].runners) {
          setRunners(JSON.parse(data[0].runners || []));
        } else {
          setRunners([]);
        }
        if (data[0].stopTime) {
          setStopTime(data[0].stopTime);
          setStatus('Stopped');
        }
        setLoading(false);
      })
      .catch((err) => {
        alert(err);
        setLoading(false);
        console.log(err);
      })
  }

  useEffect(() => {
    if (!runners) return;
    runners.forEach((runner) => {
      runner.laps.filter((l, i) => i === 0 ? true : l === runner.laps[i - 1]);
    })
  }, [runners]);

  useEffect(() => {
    inputRef?.current?.focus();
  })

  function sendObject(obj: Object) {
    socket?.send(JSON.stringify(obj));
  }

  const onSocketMessage = (event: any) => {
    let s;
    try {
      s = (JSON.parse(event.data));
    } catch (e) {
      return;
    }
    // console.log('MESSAGE', s.data);
    if (!(event.data)) {
      return;
    }
    const eventData = JSON.parse(event.data);
    // console.log(eventData);
    const data = eventData.data;
    switch (eventData.action) {
      case 'Start':
        setStartTime(data.time);
        setStatus('Running');
        break;
      case 'Lap':
        setRunners(JSON.parse(data));
        break;
      case 'Stop':
        setRunners(JSON.parse(data));
        break;
      case 'AddRunner':
        const newRunner = data.person;
        setRunners([...runners, { name: newRunner, laps: [], stopTime: 0 }])
        break;
      case 'EditLap':
        setRunners(JSON.parse(data));
        break;
      case 'StopAll':
        setStopTime(data.time);
        setStatus('Stopped');
        break;
      case 'Reset':
        if (saved) {
          doReset();
        } else {
          setResetModalOpen(true);
        }
        break;
      default:
        console.log("Action not recognized: " + data.action);
    }
  }

  function start() {
    const time = Date.now();
    setStartTime(time);
    setStatus('Running');
    const obj = { action: 'Start', sessionId: session, time: time }
    sendObject(obj);
  }

  function lap(person: string) {
    const time = Date.now();
    const obj = { action: 'Lap', sessionId: session, person: person, time: time, comment: '' }
    const runnersCopy = runners.map((r) => r.name === person ? { name: r.name, laps: [...r.laps, { time, comment: '' }], stopTime: 0 } : r);
    setRunners(runnersCopy);
    sendObject(obj);
  }

  function stop(person: string) {
    const time = Date.now();
    const obj = { action: 'Stop', sessionId: session, person: person, time: time };
    const runnersCopy = runners.map((r) => r.name === person ? { name: r.name, laps: r.laps, stopTime: time } : r);
    setRunners(runnersCopy);
    sendObject(obj);
  }

  function addPerson() {
    if (addingRunner.length === 0) {
      return;
    }
    const obj = { action: 'AddRunner', sessionId: session, person: addingRunner };
    sendObject(obj);
    setRunners([...runners, { name: addingRunner, laps: [], stopTime: 0 }]);
    setModalOpen(false);
    setAddingRunner('');
  }

  function editLap(newRunners: Runner[]) {
    const obj = { action: 'EditLap', sessionId: session, runners: newRunners };
    sendObject(obj);
    setRunners(newRunners);
  }

  function stopAll() {
    const time = Date.now();
    const obj = { action: 'StopAll', sessionId: session, time };
    sendObject(obj);
    setStopTime(time);
    setStatus('Stopped');
  }

  function reset() {
    const obj = { action: 'Reset', sessionId: session };
    sendObject(obj);
    doReset();
  }

  function doReset() {
    setSaved(false);
    setStartTime(Date.now());
    setStopTime(0);
    setRunners([]);
    setStatus('Not Started');
  }

  function save() {
    localStorage.setItem(`Saved Watch ${name} (${session as string}-${startTime.toString()})`,
      JSON.stringify({
        startTime,
        stopTime,
        runners,
        name,
        date: new Date(startTime)
      }));
    setSaved(true);
  }

  function editModal(lp: LapPair) {
    setEditModalOpen(lp)
  }

  if (loading) {
    return (<p style={{ textAlign: 'center', marginTop: '15px' }}>Loading...</p>)
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', height: 'fit-content' }}>
      <button onClick={() => history.push('/')} style={{ position: 'absolute', top: '.75rem', left: '.75rem', backgroundColor: '#c96363', fontSize: '1.5em', display: 'flex', justifyContent: 'center', alignItems: 'center', borderRadius: '999px' }}><BackIcon fontSize='inherit' /></button>
      <h1 className='title'>{name}</h1>
      <p style={{ textAlign: 'center', marginBottom: '5px' }}>
        {'Session code: ' + session}
        <Link fontSize='small' className='copy-icon' onClick={() => navigator.clipboard.writeText(`You're being invited to the ${name} shared stopwatch! Join session ${session} with the following link: https://main.d2pbcgbbfpei5h.amplifyapp.com/stopwatch/${session}`)} />
      </p>
      {status === 'Running' ? <Timer startTime={startTime} /> : (status === 'Stopped' ? <StaticTimer time={stopTime - startTime} /> : <StaticTimer time={0} />)}
      {status === 'Not Started' && <button onClick={start} style={{ width: '250px', height: '20%', backgroundColor: '#63c977', borderRadius: '10px' }}>Start</button>}
      {runners?.map((runner, i) =>
        <RunnerRow
          onRowClick={() => { }}
          onLapClick={() => lap(runner.name)}
          onStopClick={() => stop(runner.name)}
          runner={runner}
          startTime={startTime}
          setEditModalOpen={editModal}
        />
      )}
      {status === 'Running' && runners.reduce((b, runner) => b && (runner.stopTime !== 0), true) && <button className='stop-button' onClick={stopAll}>Stop</button>}
      {status === 'Stopped' &&
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '15rem', minWidth: '150px' }}>
          <button className='stop-button' style={{ backgroundColor: '#63bdc9', flex: 'flex-grow', marginRight: '1rem' }} onClick={save}>{saved ? 'Saved' : 'Save'}</button>
          <button className='stop-button' style={{ backgroundColor: '#c96363', flex: 'flex-grow', marginLeft: '1rem' }} onClick={reset}>Reset</button>
        </div>}
      <button onClick={() => setModalOpen(true)} style={{ width: '120px', height: '36px', border: '2px solid black', borderRadius: '10px', backgroundColor: "#9498f2", marginTop: "20px" }}><Plus /></button>

      {modalOpen ?
        <Modal title="Add runners" primaryButtonText="Enter" primaryButtonClick={() => addPerson()} secondaryButtonText='Cancel' secondaryButtonClick={() => setModalOpen(false)}>
          <p style={{ textAlign: 'center' }}>Add a runner that you want to time</p>
          <input ref={inputRef} className='input' style={{ backgroundColor: '#f0f0ff', borderRadius: '7px' }} value={addingRunner} onChange={(e) => setAddingRunner(e.target.value)} />
        </Modal>
        :
        null
      }
      {resetModalOpen &&
        <Modal title="Resetting" primaryButtonText="Save" primaryButtonClick={() => { save(); doReset(); setResetModalOpen(false) }} secondaryButtonText="Discard" secondaryButtonClick={() => { doReset(); setResetModalOpen(false) }}>
          <p style={{ textAlign: 'center' }}>This session is being reset by another user. This is your last chance to save its data.</p>
        </Modal>
      }
      {editModalOpen &&
        <EditLap runners={runners} submit={(r) => editLap(r)} lap={editModalOpen} startTime={startTime} close={() => setEditModalOpen(undefined)} />
      }
    </div>
  )
}

interface runnerRowProps {
  runner: Runner,
  startTime: number,
  onRowClick: () => void,
  onLapClick: () => void,
  onStopClick: () => void,
  buttonless?: boolean,
  setEditModalOpen: (lp: LapPair) => void
}
export function RunnerRow(props: runnerRowProps) {
  const [expanded, setExpanded] = useState(false);

  const lapTimes: string[] = [];
  const totalTimes: string[] = []
  props.runner.laps.forEach((lap, i) => {
    if (i == 0) {
      lapTimes.push(FormatTime(props.runner.laps[0].time - props.startTime));
    } else {
      lapTimes.push(FormatTime(props.runner.laps[i].time - props.runner.laps[i - 1].time));
    }
    totalTimes.push(FormatTime(props.runner.laps[i].time - props.startTime));
  });

  if (props.runner.stopTime !== 0) {
    lapTimes.push(FormatTime(props.runner.stopTime - props.runner.laps[props.runner.laps.length - 1].time));
    totalTimes.push(FormatTime(props.runner.stopTime - props.startTime));
  }

  // const lapString = lapTimes.reduce((s, lap, i) => s + lap + (i !== lapTimes.length - 1 ? ',   ' : ''), '');

  return (
    <div className='outside-container'>
      <div onClick={props.onRowClick} className='row-container'>
        <div className='kinda-left-div'>
          <div className='left-div'>
            <button className='expand-btn' onClick={() => setExpanded(!expanded)} >{expanded ? <ExpandLess fontSize='inherit' /> : <ExpandMore fontSize='inherit' />}</button>
            <p style={{ marginBottom: '0px', alignSelf: 'flex-end', textAlign: 'left' }}>{props.runner.name}</p>
          </div>
          {!expanded && <p className='laps'>{lapTimes.length + ' laps'}</p>}
        </div>

        {props.runner.stopTime === 0 && !props.buttonless ?
          <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'flex-end', width: '150px', minWidth: '150px' }}>
            <button onClick={props.onLapClick} className='button' style={{ backgroundColor: '#63bdc9' }}>Lap</button>
            <button onClick={props.onStopClick} className='button' style={{ backgroundColor: '#c96363' }}>Stop</button>
          </div>
          :
          <div style={{ display: 'flex', flexDirection: 'row-reverse', alignSelf: 'flex-end', width: 'fit-content' }}>
            <p style={{ marginBottom: '0px', alignSelf: 'flex-end', marginLeft: '10px', textAlign: 'right', fontSize: '20px' }}>{FormatTime(props.runner.stopTime - props.startTime)}</p>
          </div>
        }
      </div>

      {expanded ?
        <>
          <LapRow lapTime={'Lap Time'} lapNumber={"Lap"} totalTime={"Total Time"} />
          {lapTimes.map((_, i) =>
            <LapRow
              lapTime={lapTimes[i]}
              lapNumber={(i + 1) + ""}
              totalTime={totalTimes[i]}
              onClick={() => props.setEditModalOpen({ name: props.runner.name, lap: i })}
              comment={props.runner.laps[i]?.comment}
            />)}
        </>
        :
        <div />
      }
    </div>
  )

  interface LapRowProps {
    lapTime: string,
    lapNumber: string,
    totalTime: string,
    onClick?: () => void,
    comment?: string
  }
  function LapRow(props: LapRowProps) {
    const [commentOpen, setCommentOpen] = useState(false);
    const [lapEditModal, setLapEditModal] = useState(false);
    return (
      <div className='lap-container'>
        <div className='lap-row' >
          <p>{props.lapNumber}</p>
          <p>{props.lapTime}</p>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <p>{props.totalTime}</p>
            {props.lapNumber != 'Lap' &&
              <>
                <button onClick={props.onClick} className='edit-button'><EditIcon fontSize='inherit' /></button>
                <button
                  className={`expand-btn2${props.comment? '' : '-disabled'}`}
                  onClick={props.comment? () => setCommentOpen(!commentOpen) : () => {}} >
                  {commentOpen ? <ExpandLess fontSize='inherit' /> : <ExpandMore fontSize='inherit' />}
                </button>
              </>
            }
          </div>
        </div>
        {props.comment && commentOpen &&
          <>
            <p className='comment' style={{alignSelf: 'flex-start'}}>{props.comment}</p>
          </>
        }
      </div>
    )
  }
}